import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { bookingUrl, contactInfo } from '../data/mock';

const MobileCtaBar = () => (
  <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 bg-[#010c23] border-t border-white/10 shadow-[0_-8px_24px_rgba(1,12,35,0.25)]" data-testid="mobile-cta-bar">
    <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-white/90 hover:text-white" data-testid="mobile-cta-call">
      <Phone size={16} className="text-[#ff7300]" /> Appeler
    </a>
    <a href={bookingUrl} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 py-4 text-sm font-medium bg-[#ff7300] text-white" data-testid="mobile-cta-booking">
      <Calendar size={16} /> Rendez-vous en ligne
    </a>
  </div>
);

export default MobileCtaBar;
